import { atom } from 'recoil';

export const authRedirectAtom = atom<string | undefined>({
    key: 'authRedirectAtom',
    default: undefined,
});
